// src/components/RequireAuth.jsx
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import SOURCE_MAP from '../config/sourceMap';
import usePermissionRefresh from '../hooks/usePermissionRefresh';

export default function RequireAuth() {
  const { isAuthenticated, initialized, source } = useSelector((s) => s.auth);
  const location = useLocation();

  const hasToken = !!localStorage.getItem('authToken');

  // Auto-refresh permissions when cache expires or window regains focus
  // (must be called before any conditional returns — React hooks rule)
  usePermissionRefresh();

  if (!initialized && !hasToken) return null;

  if (isAuthenticated || hasToken) {
    return <Outlet />;
  }

  // not authenticated -> redirect to branded login
  const s = source || localStorage.getItem('source') || 'wayuvega';
  const route = (SOURCE_MAP[s] && SOURCE_MAP[s].loginRoute) || '/login';
  return <Navigate to={route} replace state={{ from: location }} />;
}
